import realCelebrityService from './celebrityService';
import mockCelebrityService from './mockCelebrityService';
import { USE_MOCK_DATA } from '../config/environment';

// Export the appropriate service based on environment
export const celebrityService = USE_MOCK_DATA ? mockCelebrityService : realCelebrityService;

// Re-export for convenience
export default celebrityService;